import React from 'react';
import { motion } from 'framer-motion';
import { PackVisual } from './PackVisual';
import { ArrowRight } from 'lucide-react';
interface PackCardProps {
  title: string;
  description: string;
  packTitle: string;
  themeColor: 'blue' | 'green' | 'pink' | 'purple' | 'teal' | 'navy';
  imageSrc?: string;
  href: string;
  delay: number;
}
export function PackCard({
  title,
  description,
  packTitle,
  themeColor,
  imageSrc,
  href,
  delay
}: PackCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay,
    ease: 'easeOut'
  }} whileHover={{
    y: -5,
    transition: {
      duration: 0.2
    }
  }} className="bg-white rounded-[2rem] p-6 flex flex-col shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-shadow duration-300 border border-gray-100 h-full w-full max-w-[320px] lg:max-w-[300px] overflow-hidden" data-id="element-1">
      <a href={href} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-2">
        <PackVisual title={packTitle} themeColor={themeColor} imageSrc={imageSrc} data-id="element-3" />
      </a>

      <div className="flex flex-col flex-grow text-center mt-2" data-id="element-4">
        <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5">{title}</h3>
        <p className="text-sm text-gray-500 leading-relaxed mb-8 flex-grow" data-id="element-6">
          {description}
        </p>

        <a href={href} target="_blank" rel="noopener noreferrer" className="w-full min-h-[56px] bg-[#0F0F0F] hover:bg-black text-white font-bold px-6 rounded-full flex items-center justify-center gap-2 transition-transform active:scale-95 group mt-auto whitespace-nowrap text-base leading-none" data-id="element-7">
          <span data-id="element-8">Quiero Mi MegaPack Ahora</span>
          <ArrowRight className="w-4 h-4 shrink-0 group-hover:translate-x-1 transition-transform" data-id="element-9" />
        </a>
      </div>
    </motion.div>;
}